import axios from "axios";
import { useState, useEffect } from "react";
import { toast } from "react-hot-toast";
import CamperTable from "../components/tables/CamperTable";
import GroupsTable from "../components/tables/GroupsTable";
import ShirtSizeTable from "../components/tables/ShirtSizeTable";
import { admin_navigation_items } from "../utils/NavigationItems";
import "../styles/home.css";
import "../styles/admin.css";

export default function RegisteredCampersView() {
  const [campers, setCampers] = useState(null);
  const [total, setTotal] = useState(0);
  const [loadError, setLoadError] = useState(null);

  const grabCampers = (updating) => {
    const loadingToast = updating ? toast.loading("Updating payment…") : null;

    axios
      .get("https://api.houstonsikhyouthcamp.org/campers", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        setCampers(res.data.data);
        setTotal(res.data.total);
        setLoadError(null);
        if (updating) {
          toast.dismiss(loadingToast);
          toast.success("Payment updated");
        }
      })
      .catch((e) => {
        if (updating) toast.dismiss(loadingToast);
        const status = e.response?.status;
        setLoadError(status === 401 || status === 403 ? "auth" : "network");
      });
  };

  useEffect(() => {
    grabCampers();
  }, []);

  const list = campers || [];
  const paid = list.filter((c) => c.paid).length;
  const flying = list.filter((c) => c.camperFlying === "yes").length;

  const stats = [
    ["Registered", total],
    ["Paid", paid],
    ["Not paid", list.length - paid],
    ["Flying in", flying],
  ];

  return (
    <div className="hsyc adm">
      <header className="adm-bar">
        <div className="adm-wrap adm-bar__inner">
          <a href="/" className="hsyc-nav__logo">
            <img src="/camplogo.png" alt="Houston Sikh Youth Camp home" />
          </a>
          <nav aria-label="Admin">
            <ul className="adm-bar__links">
              {admin_navigation_items
                .filter((item) => item.enabled && item.href_field !== "/")
                .map((item) => (
                  <li key={item.id}>
                    <a
                      href={item.href_field}
                      aria-current={
                        item.href_field === "/admin/campers" ? "page" : undefined
                      }
                    >
                      {item.display_name}
                    </a>
                  </li>
                ))}
            </ul>
          </nav>
        </div>
      </header>

      <main className="adm-wrap adm-main">
        <h1>Winter camp 2026 campers</h1>

        {loadError === "auth" && (
          <div className="adm-alert" role="alert">
            Your admin session has expired.{" "}
            <a href="/admin/login">Log in again</a> to see campers.
          </div>
        )}
        {loadError === "network" && (
          <div className="adm-alert" role="alert">
            Couldn't load campers from the server.{" "}
            <button type="button" className="adm-textbtn" onClick={() => grabCampers()}>
              Try again
            </button>
          </div>
        )}

        <dl className="adm-stats">
          {stats.map(([label, value]) => (
            <div key={label} className="adm-stat">
              <dt>{label}</dt>
              <dd>{campers ? value : "–"}</dd>
            </div>
          ))}
        </dl>

        <div className="adm-breakdowns">
          <GroupsTable campers={campers} />
          <ShirtSizeTable campers={campers} />
        </div>

        <CamperTable campers={campers} callback_request={grabCampers} />
      </main>
    </div>
  );
}
